import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import 'react-data-table-component-extensions/dist/index.css';
import { fitActionColumn } from "../../../Utils/actionColumn";

const CustomTable = ({ columns, data }) => {
    const [searchData, setSeacrhData] = useState('');
    const [filterData, setFilterData] = useState([]);

    const onSearch = (value) => {
        setSeacrhData(value);
        const searchRes = data.filter((o) =>
            Object.keys(o).some((k) =>
                String(o[k]).toLowerCase().includes(value.toLowerCase())
            )
        );
        setFilterData(searchRes);
    };
    const customStyles = {
        table: { style: { tableLayout: 'fixed' } },
        headRow: { style: { backgroundColor: '#f1f1f1', color: '#333', fontSize: '13px', minHeight: '36px' } },
        headCells: { style: { paddingLeft: '8px', paddingRight: '8px', paddingTop: '6px', paddingBottom: '6px', fontWeight: 'bold', fontSize: '13px' } },
        rows: { style: { minHeight: '32px', paddingTop: '0px', paddingBottom: '0px', fontSize: '13px', backgroundColor: '#fff', '&:nth-child(odd)': { backgroundColor: '#f9f9f9' } } },
        cells: { style: { paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px' } },
        pagination: { style: { minHeight: '40px', fontSize: '13px' } },
      };
    return (
        <>
            <div className='searc-bar'>
                <input type="search" className="form-control me-2 float-end" placeholder='Search here...' onChange={(e) => onSearch(e.target.value)} />
            </div>
            <DataTable
                noHeader
                columns={fitActionColumn(columns, data)}
                data={searchData ? filterData : data}
                defaultSortField="id"
                defaultSortAsc={false}
                pagination
                paginationPerPage={20}
                highlightOnHover
                customStyles={customStyles}
            />
        </>
    )
}


export default CustomTable;
